import { useEffect, useState } from "react";
import api from "@/lib/api";

let postersPromise = null;
function loadPosters() {
  if (!postersPromise) {
    postersPromise = api
      .get("/shows")
      .then((r) => (r.data || []).filter((s) => s.image_url).map((s) => s.image_url))
      .catch(() => {
        postersPromise = null;
        return [];
      });
  }
  return postersPromise;
}

export function PageHero({ overline, title, intro, callout, offset = 0 }) {
  const [urls, setUrls] = useState([]);

  useEffect(() => {
    let active = true;
    loadPosters().then((u) => { if (active) setUrls(u); });
    return () => { active = false; };
  }, []);

  const picks = urls.length
    ? Array.from({ length: Math.min(4, urls.length) }, (_, i) => urls[(offset * 4 + i) % urls.length])
    : [];
  const CalloutIcon = callout?.icon;

  return (
    <section className="relative overflow-hidden border-b border-amber-900/20">
      <div className="absolute inset-0 flex">
        {picks.length > 0 ? (
          picks.map((src, i) => (
            <img key={i} src={src} alt="" className="h-full w-1/4 scale-125 object-cover opacity-60 blur-2xl" />
          ))
        ) : (
          <div className="h-full w-full bg-[#161118]" />
        )}
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-[#0D0A0E]/50 via-[#0D0A0E]/75 to-[#0D0A0E]" />
      <div className="grain absolute inset-0" />
      <div className="relative z-10 mx-auto max-w-7xl px-4 py-10 sm:px-6 sm:py-14">
        {overline && <p className="overline-label text-[#C89B3C]">{overline}</p>}
        <h1 className="mt-2 font-serif text-4xl font-semibold text-amber-50 sm:text-5xl">{title}</h1>
        {intro && <p className="mt-3 max-w-xl text-amber-100/70">{intro}</p>}
        {callout && (
          <div className="mt-5 flex items-start gap-3 rounded-2xl border border-[hsl(var(--gold))]/30 bg-white/5 px-5 py-4 backdrop-blur-sm">
            {CalloutIcon && <CalloutIcon className="mt-1 h-5 w-5 flex-shrink-0 text-[hsl(var(--gold))]" />}
            <p className="text-base text-amber-100/80">
              <span className="font-semibold text-amber-50">{callout.lead}</span> {callout.text}
            </p>
          </div>
        )}
      </div>
    </section>
  );
}